import type { BookingDetails } from 'routes/tourOperator/bookings/types/bookingDetails/bookingDetailsTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type BookingInsurancesState = {
  value: BookingDetails['insurances'] | null;
};

const initialState: BookingInsurancesState = {
  value: null,
};

function setBookingInsurancesFunction(
  state: BookingInsurancesState,
  action: PayloadAction<BookingInsurancesState['value']>
) {
  return {
    ...state,
    value: action.payload,
  };
}

function resetStateFunction() {
  return initialState;
}

const slice = createSlice({
  name: 'bookingDetails.bookingInsurances',
  initialState,
  reducers: {
    setBookingInsurances: setBookingInsurancesFunction,
    resetState: resetStateFunction,
  },
});

export const { setBookingInsurances, resetState } = slice.actions;
export default slice.reducer;
